import classNames from "classnames";

const Error = ({ value, className }) => {
    return <div className={classNames('widget-error', className)}>{value}</div>;
}

export default Error;